import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Container,
  Image,
  Dropdown,
  Form,
  Spinner,
} from "react-bootstrap";
import { TenantContext } from "../../context/tenant/TenantContext";
import { ClientContext } from "../../context/client/ClientContext";
import { CardContext } from "../../context/card/CardContext";

// import DOMPurify from "dompurify";
import "./tenantheader.css";
import Skeleton from "../skeletons/Skeleton";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { offerwallapi } from "../../config/axiosconfig";
import { LanguageContext } from "../../context/language/LanguageContext";
import { OffersContext } from "../../context/offers/OffersContext";
import { CheckAuth } from "../../utils/auth";
import Cookies from "universal-cookie";
import { CategoriesContext } from "../../context/categories/CategoriesContext";
import DOMPurify from "dompurify";
import { ParamsContext } from "../../context/params/ParamsContext";

export default function TenantHeader() {
  const navigate = useNavigate();
  const url = useLocation().pathname.split("/");
  const urlPath = url[2];
  const page = url[3];
  const params = useParams();
  const tenanturl = params.tenanturlpathname;
  const { awsparams, paramsdispatch } = useContext(ParamsContext);
  const { tenant, tenantdispatch } = useContext(TenantContext);
  const { client, clientdispatch } = useContext(ClientContext);
  const { language, languagedispatch } = useContext(LanguageContext);
  const { card, carddispatch } = useContext(CardContext);
  const [languages, setLanguages] = useState([]);
  const [myCards, setMyCards] = useState([]);
  const [defaultCard, setDefaultCard] = useState("");
  const [isSignInClicked, setIsSignInClicked] = useState(false);
  const [isSignUpClicked, setIsSignUpClicked] = useState(false);
  const { offersdispatch } = useContext(OffersContext);
  const { categoriesdispatch } = useContext(CategoriesContext);

  const cboxMyCards = useRef();
  const [loader, setLoader] = useState(false);

  const cookies = new Cookies();

  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    // if (tenant) getLanguages();

    // if (localStorage.getItem("l")) {
    //     const lang = JSON.parse(localStorage.getItem("l"))
    //     if (lang.languageid === 490) {
    //         localStorage.removeItem("l")
    //     }
    // }

    // const { languageid, languagecode } = { languageid: 489, languagecode: "en", languagename: "English" }

    const { languageid, languagecode } = localStorage.getItem("l")
      ? JSON.parse(localStorage.getItem("l"))
      : { languageid: null, languagecode: null, languagename: null };

    // : { languageid: 529, languagecode: "ja", languagename: "Japanese" };

    getLanguage(languageid, languagecode, false);
    getAwsParams();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (tenant) {
      getLanguages();

      /*
       * comment the below setInterval block to remove the redirection to the login page on local env
       */
      setInterval(() => {
        if (localStorage.getItem("c")) {
          if (!cookies.get("ow-c")) {
            // cookies.get"ow-c")
            localStorage.removeItem("c");
            setTimeout(() => {
              window.location.replace(`/${DOMPurify.sanitize(tenanturl)}/auth`);
            }, 2000);
          }
        }
      }, 2000);
    }
  }, [tenant]);

  const getLanguages = async () => {
    try {
      const res = await offerwallapi.get(
        "/api/public/tenantmultilingual/" + tenant.tenantid
      );

      setLanguages(res.data);
    } catch (err) { }
  };

  const getAwsParams = async () => {
    paramsdispatch({ type: "PARAMS_START" });
    try {
      const res = await offerwallapi.get("/api/common/get-aws-params");
      if (res.status === 200) {
        paramsdispatch({ type: "PARAMS_SUCCESS", payload: res.data });
      } else {
        paramsdispatch({ type: "PARAMS_FAIL", payload: res.status });
      }
    } catch (err) {
      paramsdispatch({ type: "PARAMS_FAIL", payload: err });
    }
  };

  const getTenant = async (lanid) => {
    tenantdispatch({ type: "TENANT_START" });
    try {
      const res = await offerwallapi.get("/api/tenants/tenantgetbyurlname", {
        params: {
          tenanturlname: tenanturl, // === "gamification" ? "gamification" : "visa-japan",
          languageid: lanid,
        },
      });
      if (res.data.length === 0) navigate("/");

      const tenantobj = res.data;

      await localStorage.setItem(
        "l",
        JSON.stringify({
          languageid: tenantobj.languageid,
          languagecode: tenantobj.languagecode,
        })
      );

      res.data.tenantmasterconfig = JSON.parse(res.data.tenantmasterconfig);
      res.data.tenantcontentconfig = JSON.parse(res.data.tenantcontentconfig);

      tenantdispatch({ type: "TENANT_SUCCESS", payload: res.data });
      return {
        languageid: tenantobj.languageid,
        languagecode: tenantobj.languagecode,
      };
    } catch (err) {
      tenantdispatch({ type: "TENANT_FAIL", payload: err });
    }
  };

  // useEffect(() => {
  //     if (language && tenant) getMyCards();
  // }, [language, tenant]);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (client && tenant && language) {
      // setTimeout(() => getMyCards(), 3000);
      getMyCards();
    } else if (tenant && language) {
      // getOffers();
    }
  }, [client, tenant, language]);

  const getMyCards = async () => {
    try {
      carddispatch({ type: "CARD_START" });
      const cards = await offerwallapi.get("/api/cards/cardgetall", {
        params: {
          clientid: client.clientid,
          tenantid: tenant.tenantid,
        },
      });

      // const mycrds = [
      //     {
      //         isdefault: 1,
      //         last4digits: 4562,
      //         cardnumber: "lkhukjgu567tg77",
      //         id: 1
      //     },
      //     {
      //         isdefault: 0,
      //         last4digits: 8521,
      //         cardnumber: "asde34rddf",
      //         id: 2
      //     },
      //     {
      //         isdefault: 0,
      //         last4digits: 9874,
      //         cardnumber: "fvdsv5t5r",
      //         id: 3
      //     }
      // ]
      let cardNumber;
      cards.data.map((crd) => {
        if (crd.isdefault === 1) cardNumber = crd.cardnumber;
      });
      carddispatch({ type: "CARD_SUCCESS", payload: cards.data });
      // carddispatch({
      //     type: "CARD_SUCCESS", payload: [
      //         {
      //             isdefault: 1,
      //             last4digits: 4562,
      //             cardnumber: "lkhukjgu567tg77",
      //             id: 1
      //         },
      //         {
      //             isdefault: 0,
      //             last4digits: 8521,
      //             cardnumber: "asde34rddf",
      //             id: 2
      //         },
      //         {
      //             isdefault: 0,
      //             last4digits: 9874,
      //             cardnumber: "fvdsv5t5r",
      //             id: 3
      //         }
      //     ]
      // });

      // getOffers(cardNumber);
    } catch (err) {
      carddispatch({ type: "CARD_FAIL", payload: err });
    }
  };

  const getOffers = async (defCard) => {
    offersdispatch({ type: "OFFERS_SUCCESS", payload: [] });
    offersdispatch({ type: "OFFERS_START" });
    try {
      const res = await offerwallapi.get("/api/offers", {
        params: {
          tenantid: tenant.tenantid,
          languagecode: language ? language.languagecode : "en",
          cardnumber: defCard, //(cboxMyCards.current) ? cboxMyCards.current.value : "",
        },
      });
      //res.data.tenantid = tenant.tenantid;
      // offersdispatch({ type: "OFFERS_START" });
      const catList = [];
      for (const item of res.data.offers) {
        if (catList.indexOf(item.merchant.category.name) === -1) {
          catList.push(item.merchant.category.name);
        }
      }
      categoriesdispatch({ type: "CATEGORIES_SUCCESS", payload: catList });
      offersdispatch({ type: "OFFERS_SUCCESS", payload: res.data.offers });
    } catch (err) {
      offersdispatch({ type: "OFFERS_FAIL", payload: err });
    }
  };

  const getLanguage = async (lanid, lancode, isLangChange) => {



    const { languageid, languagecode } = await getTenant(lanid);
    try {
      languagedispatch({ type: "LANGUAGE_START" });
      const res = await offerwallapi.get(
        "/api/public/multilingual/" + languageid
      );

      languagedispatch({
        type: "LANGUAGE_SUCCESS",
        payload: JSON.parse(res.data.osakalanguagecontent),
      });
    } catch (err) {
      languagedispatch({ type: "LANGUAGE_FAIL", payload: err });
    }
    if (client) {
      updateClientLanguage(languageid, languagecode, isLangChange);
    } else {
      if (isLangChange)
        window.location.reload()
    }
  };

  const clientSignout = async () => {
    try {
      setLoader(true);
      await offerwallapi.post("/api/clients/clientsignout", {
        clientid: client.clientid,
        tenantid: tenant.tenantid,
      });



      // cookies.remove("rtid");
      // cookies.remove("at");
      // cookies.remove("as");
      // cookies.remove("rt");
      // cookies.remove("ow-c");

      setTimeout(function () {
        clientdispatch({ type: "CLIENT_SIGNOUT" });
        carddispatch({ type: "CARD_START" });
        getOffers();
        navigate(`/${tenanturl}`);
        setLoader(false);
      }, 3000);
    } catch (e) {
      console.log(e);
    }
  };

  const updateClientLanguage = async (lanid, lancode, isLangChange) => {
    try {
      const res = await offerwallapi.put("/api/clients/clientlanguageupdate", {
        tenantid: tenant.tenantid,
        clientid: client.clientid,
        languageid: lanid,
      });
      const clientobj = client;
      clientobj.defaultlanguageid = lanid;
      clientobj.languagecode = lancode;
      clientdispatch({ type: "CLIENT_SUCCESS", payload: clientobj });
      if (isLangChange)
        window.location.reload()
    } catch (err) { }
  };

  useEffect(() => {
    if (tenant) {
      setTimeout(() => {
        const inp = document.getElementById("txtGlobalSearch");
        inp?.addEventListener("keydown", function (e) {
          if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            globalSearch("txtGlobalSearch");
          }
        });
      }, 2000);
    }
  }, [tenant]);

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = `${process.env.REACT_APP_CLOUDFRONT}favicons/visa-japan.ico`;
  }, []);

  const globalSearch = (element) => {
    const searchparam = document.getElementById(element).value;
    if (searchparam !== "") navigate(`/${tenanturl}/search/${searchparam}`);
  };

  useEffect(() => {
    if (showSearch) {
      const inpMob = document.getElementById("txtGlobalSearchMob");
      inpMob?.removeEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          globalSearch("txtGlobalSearchMob");
        }
      });
      inpMob?.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          globalSearch("txtGlobalSearchMob");
        }
      });
    } else {
      const inpMob = document.getElementById("txtGlobalSearchMob");
      inpMob?.removeEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          globalSearch("txtGlobalSearchMob");
        }
      });
    }
  }, [showSearch]);

  return (
    <header className="header_area sticky-top">
      <div
        className="header_navbar d-none d-md-block"
        style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}
      >
        <div className="container">
          <nav className="navbar navbar-expand-md pb-2 pt-2">
            <button
              className="navbar-toggler me-2 border-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <Link className="navbar-brand mr-auto" to={`/${tenanturl}`}>
              <img
                src={`${process.env.REACT_APP_CLOUDFRONT}${tenant?.tenantlogo}`}
                alt="Logo"
              />
            </Link>
            <div
              id="divSearchContainer"
              className="input-group col"
              style={{ width: "240px", maxWidth: "240px" }}
            >
              <span className="input-group-text bg-none" id="basic-addon1">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                id="txtGlobalSearch"
                className="form-control"
                placeholder={language?.static_labels.search}
                aria-label="Search"
                aria-describedby="basic-addon1"
              />
            </div>
            {/* <div className="dropdown ms-1 d-block d-md-none">
                        <button className="btn btn-outline-secondary dropdown-toggle text-uppercase" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="bi bi-translate text-primary"></i> {language?.languagecodetranslate} <i className="bi bi-chevron-down"></i>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end">
                            {
                                (languages) ?
                                    languages.map((lan, index) => {
                                        return <li key={index} onClick={() => { getLanguage(lan.languageid, lan.languagecode) }} className="dropdown-item">
                                            {lan.languagenametranslate}
                                        </li>
                                    })
                                    : ""
                            }
                        </ul>
                    </div> */}
            {/* <div className={`dropdown ms-2 ${client ? " d-block d-md-none" : "d-none"}`}>
                        <button className="border rounded-circle show" type=""
                            data-bs-toggle="dropdown" aria-expanded="true"
                            style={{
                                fontSize: "34px", color: "#0265ad", backgroundColor: "#e7f5ff"
                            }}><i className="bi bi-person-circle h-100"></i></button>
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li><Link to={`/visa-japan/user/account`} className="dropdown-item">aaa{language?.static_labels.profile}</Link></li>
                            <li><Link to={`/visa-japan/user/mycards`} className="dropdown-item">bbb{language?.static_labels.mycards}</Link></li>
                            <li><Link onClick={clientSignout} className="dropdown-item">{language?.static_labels.signout}</Link></li>
                        </ul>
                    </div> */}
            <div
              className="collapse navbar-collapse sub-menu-bar"
              id="navbarSupportedContent"
            >
              <ul id="nav" className="navbar-nav mr-auto">
                <li className="nav-item-r">
                  <Link
                    to={`/${tenanturl}/terms`}
                    className="text-decoration-none text-dark p-2 ps-3 d-block"
                  >
                    {language?.static_labels.termsandconditions}
                  </Link>
                </li>
                <li className="nav-item-r">
                  {
                    tenant?.tenantcontentconfig?.FAQ?.isLink ?
                      <a className="text-decoration-none text-dark p-2 ps-3 d-block" href={tenant?.tenantcontentconfig.FAQ.link} target="_blank">
                        {tenant?.tenantfaqdisplay}
                      </a>
                      : <Link
                        to={`/${tenanturl}/faq`}
                        className="text-decoration-none text-dark p-2 ps-3 d-block"
                      >
                        {tenant?.tenantfaqdisplay}
                      </Link>
                  }

                </li>
              </ul>
              <ul id="nav" className="navbar-nav ms-auto me-0 ">
                <li className="nav-item-r d-none d-md-block">
                  <div className="dropdown">
                    <button
                      className="btn btn-outline-secondary dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bi bi-translate text-primary"></i>{" "}
                      {language?.languagenametranslate}{" "}
                      <i className="bi bi-chevron-down"></i>
                    </button>
                    <ul className="dropdown-menu">
                      {languages
                        ? languages.map((lan, index) => {
                          return (
                            <li
                              key={index}
                              onClick={() => {
                                getLanguage(lan.languageid, lan.languagecode, true);
                              }}
                              className="dropdown-item"
                            >
                              {lan.languagenametranslate}
                            </li>
                          );
                        })
                        : ""}
                    </ul>
                  </div>
                </li>
                {
                  (tenant?.tenantallowsignup ?
                    <>
                      <li
                        className={`nav-item-r ${client ? "d-none" : " d-none d-md-block"
                          }`}
                      >
                        <Link
                          className="btn btn-outline-primary ms-md-2 text-decoration-none"
                          to={`/${tenanturl}/signin`}
                          onClick={() =>
                            setIsSignInClicked((currentState) => !currentState)
                          }
                          state={{ fromLink: isSignInClicked }}
                        >
                          {language?.static_labels.signin}
                        </Link>
                      </li>
                      {/* signUp btn - navbar desktop view*/}
                      <li
                        className={`nav-item-r ${client ? "d-none" : "d-none d-md-block"
                          }`}
                      >
                        <Link
                          className="btn btn-primary ms-2 text-decoration-none"
                          to={`/${tenanturl}/signup`}
                          onClick={() =>
                            setIsSignUpClicked((currentState) => !currentState)
                          }
                          state={{ fromLink: isSignUpClicked }}
                        >
                          {language?.static_labels.signup}
                        </Link>
                      </li>
                    </>

                    : ""
                  )

                }
                {/* signIn btn - navbar desktop view*/}

                <li
                  className={`nav-item-r ${client ? " d-none d-md-block" : "d-none"
                    }`}
                >
                  <div className={`dropdown ms-2`}>
                    <button
                      className="border rounded-circle show"
                      type=""
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                      style={{
                        fontSize: "34px",
                        color: "#0265ad",
                        backgroundColor: "#e7f5ff",
                      }}
                    >
                      <i className="bi bi-person-circle h-100"></i>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <Link
                          to={`/${tenanturl}/user/account`}
                          className="dropdown-item"
                        >
                          {language?.static_labels.profile}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/${tenanturl}/user/mycards`}
                          className="dropdown-item"
                        >
                          {language?.static_labels.mycards}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={clientSignout} className="dropdown-item">
                          {language?.static_labels.signout}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>

      <div
        className="header_navbar d-block d-md-none"
        style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}
      >
        <div className="container">
          <nav className="navbar navbar-expand-md pb-2 pt-2">
            <button
              id="btnnavbarSupportedContentMob"
              className="navbar-toggler me-2 border-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContentMob"
              aria-controls="navbarSupportedContentMob"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <Link className="navbar-brand mr-auto" to={`/${tenanturl}`}>
              <img
                src={`${process.env.REACT_APP_CLOUDFRONT}${tenant?.tenantlogo}`}
                alt="Logo"
              />
            </Link>
            {showSearch ? (
              ""
            ) : (
              <div className="dropdown ms-1 d-block d-md-none">
                <button
                  className="btn btn-outline-secondary dropdown-toggle text-uppercase"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-translate text-primary"></i>{" "}
                  {language?.languagecodetranslate}{" "}
                  <i className="bi bi-chevron-down"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  {languages
                    ? languages.map((lan, index) => {
                      return (
                        <li
                          key={index}
                          onClick={() => {
                            getLanguage(lan.languageid, lan.languagecode, true);
                          }}
                          className="dropdown-item"
                        >
                          {lan.languagenametranslate}
                        </li>
                      );
                    })
                    : ""}
                </ul>
              </div>
            )}

            {showSearch ? (
              <div
                id="divSearchContainer"
                className="input-group col"
                style={{ width: "240px", maxWidth: "240px" }}
              >
                <span className="input-group-text bg-none" id="basic-addon2">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  id="txtGlobalSearchMob"
                  className="form-control"
                  placeholder={language?.static_labels.search}
                  aria-label="Search"
                  aria-describedby="basic-addon2"
                  enterkeyhint="search"
                />
                <span
                  className="input-group-text bg-none border-0"
                  id="basic-addon1"
                  onClick={() => {
                    setShowSearch(false);
                  }}
                >
                  <i className="bi bi-x-lg"></i>
                </span>
              </div>
            ) : (
              <div
                onClick={() => {
                  setShowSearch(true);
                }}
              >
                <i className="bi bi-search"></i>
              </div>
            )}
            {showSearch ? (
              ""
            ) : client ? (
              <div className={`dropdown ms-2 d-block d-md-none"`}>
                <button
                  className="border rounded-circle show"
                  type=""
                  data-bs-toggle="dropdown"
                  aria-expanded="true"
                  style={{
                    fontSize: "34px",
                    color: "#0265ad",
                    backgroundColor: "#e7f5ff",
                  }}
                >
                  <i className="bi bi-person-circle h-100"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link
                      to={`/${tenanturl}/user/account`}
                      className="dropdown-item"
                    >
                      {language?.static_labels.profile}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/${tenanturl}/user/mycards`}
                      className="dropdown-item"
                    >
                      {language?.static_labels.mycards}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={clientSignout} className="dropdown-item">
                      {language?.static_labels.signout}
                    </Link>
                  </li>
                </ul>
              </div>
            ) : (
              (tenant?.tenantallowsignup ?
                <div className={`dropdown ms-2 d-block d-md-none"`}>
                  <button
                    className="border-0 rounded-circle show"
                    type=""
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                    style={{
                      fontSize: "34px",
                      color: "#606060",
                      backgroundColor: "transparent",
                    }}
                  >
                    <i className="bi bi-person h-100"></i>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    {/* signIn btn - navbar small screen view*/}
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`/${tenanturl}/signin`}
                        onClick={() =>
                          setIsSignInClicked((currentState) => !currentState)
                        }
                        state={{ fromLink: isSignInClicked }}
                      >
                        {language?.static_labels.signin}
                      </Link>
                    </li>
                    {/* signUp btn - navbar small screen view*/}
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`/${tenanturl}/signup`}
                        onClick={() =>
                          setIsSignUpClicked((currentState) => !currentState)
                        }
                        state={{ fromLink: isSignUpClicked }}
                      >
                        {language?.static_labels.signup}
                      </Link>
                    </li>
                  </ul>
                </div>
                : "")
            )}

            <div
              className="collapse navbar-collapse sub-menu-bar"
              id="navbarSupportedContentMob"
            >
              <ul id="nav" className="navbar-nav mr-auto">
                <li className="nav-item-r">
                  <Link
                    to={`/${tenanturl}/terms`}
                    className="text-decoration-none text-dark p-2 ps-3 d-block"
                  >
                    {language?.static_labels.termsandconditions}
                  </Link>
                </li>
                <li className="nav-item-r">
                  {
                    tenant?.tenantcontentconfig?.FAQ?.isLink ?
                      <a className="text-decoration-none text-dark p-2 ps-3 d-block" href={tenant?.tenantcontentconfig?.FAQ?.link} target="_blank">
                        {tenant?.tenantfaqdisplay}
                      </a>
                      : <Link
                        to={`/${tenanturl}/faq`}
                        className="text-decoration-none text-dark p-2 ps-3 d-block"
                      >
                        {tenant?.tenantfaqdisplay}
                      </Link>
                  }
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
